import { useQuery } from "react-query";
import { getOfficeAppliances } from "../api/officeApplianceService";

export const useGetOfficeAppliances = () => {
  return useQuery("GetOfficeAppliance", getOfficeAppliances, {
    refetchOnWindowFocus: false,
  });
};
